import { HttpClient,HttpBackend, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { SearchResult } from 'src/domain/searchResults/searchResult';
import { AuthService } from './auth.service';
import { GlobalService } from './global.service';



@Injectable({
  providedIn: 'root'
})
export class ApiService {
  endpoint = this.globalService.endpoint;
  private httpBend: HttpClient;

  constructor(
    private http: HttpClient, 
    private auth: AuthService, 
    private globalService: GlobalService,
    private handler: HttpBackend
  ) {
    this.httpBend = new HttpClient(handler);
  }

  downloadPDF(params: any) {
    var mediaType = 'application/pdf';

    
    const url = this.endpoint + 'docs/downloadfile';
    return this.http.post<any>(url, params, {headers: this.globalService.getHeaders(), responseType:'blob' as 'json' }).pipe(map(response => {
      return response;
    }, error => {
      console.error(error);
    }));   
  }

  
  
  post(api:string,params: any) {
    const url = this.endpoint + api;
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      this.auth.updateToken(result.TokenAnswer);
      return result;
    }, error => {
      console.error(error);
    }));
  }

  /** Upload multipart: non impostare Content-Type (boundary gestito dal browser). */
  postFormData(api: string, formData: FormData) {
    const url = this.endpoint + api;
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + localStorage.getItem('login_token'),
    });
    return this.http.post<SearchResult>(url, formData, { headers }).pipe(map(result => {
      this.auth.updateToken(result.TokenAnswer);
      return result;
    }, error => {
      console.error(error);
    }));
  }
  
  
  downloadDocument(params: any) {
    var mediaType = 'application/pdf';

    
    const url = this.endpoint + 'docs/downloadfile';
    return this.http.get<any>(url, params ).pipe(map(response => {
      return response;
    }, error => {
      console.error(error);
    }));   
  }

  get(api:string,params: any) {
    const url = this.endpoint + api;
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      this.auth.updateToken(result.TokenAnswer);
      return result;
    }, error => {
      console.error(error);
    }));
  }
  
  
  
  
  // >DELETE deleteSMS
  updateEmail(params: any) {
    const url = this.endpoint + 'surveys/email-update';
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      return result;
    }, error => {
      console.error(error);
    }));
  }  
  
  

  // >DELETE deleteSMS
  deleteTarget(params: any) {
    const url = this.endpoint + 'surveys-targets/delete';
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      return result;
    }, error => {
      console.error(error);
    }));
  }  
  
  
  // >DELETE deleteSMS
  confirmEmail(params: any) {
    const url = this.endpoint + 'surveys/email-confirm';
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      return result;
    }, error => {
      console.error(error);
    }));
  }  
  // >DELETE deleteSMS
  deleteEmail(params: any) {
    const url = this.endpoint + 'surveys/email-delete';
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      return result;
    }, error => {
      console.error(error);
    }));
  }  
  
  confirmSMS(params: any) {
    const url = this.endpoint + 'surveys/sms-confirm';
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      return result;
    }, error => {
      console.error(error);
    }));
  }  
  
  // >DELETE deleteSMS
  deleteSMS(params: any) {
    const url = this.endpoint + 'surveys/sms-delete';
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      return result;
    }, error => {
      console.error(error);
    }));
  }  
  
  // >DELETE deleteSMS
  updateSMS(params: any) {
    const url = this.endpoint + 'surveys/sms-update';
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      return result;
    }, error => {
      console.error(error);
    }));
  }  

  

  // >DELETE SurveystartupModel
  deleteStartupSurveyModel(params: any) {
    const url = this.endpoint + 'surveys-startup-model/delete';
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      return result;
    }, error => {
      console.error(error);
    }));
  }  

  
  

  // >DELETE deleteSurveyCompilation
  deleteSurveyCompilation(params: any) {
    const url = this.endpoint + 'surveys/deletecompilation';
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      return result;
    }, error => {
      console.error(error);
    }));
  }  
  
  

  // >DELETE deleteSSurveyModel
  deleteSSurveyModel(params: any) {
    const url = this.endpoint + 'surveys-model/delete';
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      return result;
    }, error => {
      console.error(error);
    }));
  }  

  

  // >DELETE deleteSSurvey
  deleteSSurvey(params: any) {
    const url = this.endpoint + 'surveys/delete';
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      return result;
    }, error => {
      console.error(error);
    }));
  }  
  
  // >DELETE deleteSSurvey
  deleteRsa(params: any) {
    const url = this.endpoint + 'surveys-rsa/delete';
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      return result;
    }, error => {
      console.error(error);
    }));
  }  
  
  
  

    

  // UPDATE SurveystartupModel
  updateStartupSurveyModel(params: any) {
    const url = this.endpoint + 'surveys-startup-model/update';
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      return result;
    }, error => {
      console.error(error);
    }));
  }  

  
  // UPDATE CHECKLIST MODEL
  updateCheckl(params: any) {
    params.userid=this.globalService.loggedUser.id;
    const url = this.endpoint + 'checklists/checkl-update2';
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      return result;
    }, error => {
      console.error(error);
    }));
    }  

  // >DELETE delCheckList
  delCheckList(params: any) {
    const url = this.endpoint + 'checklists/delete';
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      return result;
    }, error => {
      console.error(error);
    }));
  }  


  // >DELETE delCheckList
  delCheckListModel(params: any) {
    const url = this.endpoint + 'checklists/deletemodel';
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      return result;
    }, error => {
      console.error(error);
    }));
  }  


  // UPDATE CHECKLIST MODEL
  updateChecklModel(params: any) {
    const url = this.endpoint + 'checklists/update';
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      return result;
    }, error => {
      console.error(error);
    }));
    }  


  // UPDATE Survey
  updateSurvey(params: any) {
    const url = this.endpoint + 'surveys-survey/update';
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      return result;
    }, error => {
      console.error(error);
    }));
    }  

  
  // UPDATE SurveyModel
  updateSurveyModel(params: any) {
    const url = this.endpoint + 'surveys-model/update';
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      return result;
    }, error => {
      console.error(error);
    }));
    }  

  
    
    
  updatersa(params: any) {
    const url = this.endpoint + 'surveys-rsa/update';
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      return result;
    }, error => {
      console.error(error);
    }));
    }  

    updatetarget(params: any) {
      const url = this.endpoint + 'surveys-targets/update';
      return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
        return result;
      }, error => {
        console.error(error);
      }));
      }  
    
  // INSERT HOMEPAGE
  insertHp(params: any) {
    const url = this.endpoint + 'hp/updinshp';
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      return result;
    }, error => {
      console.error(error);
    }));
    }  


}
